import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m12.574 7.648 1.559 3.145c.246.492.902.629 1.312.3l2.461-1.968a1.05 1.05 0 0 1-.218-.656 1.08 1.08 0 0 1 1.093-1.094c.602 0 1.094.492 1.094 1.094a1.08 1.08 0 0 1-1.094 1.094h-.027l-1.258 6.89c-.137.82-.875 1.422-1.723 1.422H8.2c-.847 0-1.586-.602-1.722-1.422l-1.258-6.89a1.063 1.063 0 0 1-1.094-1.094 1.08 1.08 0 0 1 1.094-1.094c.601 0 1.093.492 1.093 1.094 0 .246-.082.492-.218.656l2.433 1.969a.875.875 0 0 0 1.313-.301l1.586-3.145a1.03 1.03 0 0 1-.52-.93A1.08 1.08 0 0 1 12 5.626a1.092 1.092 0 0 1 .574 2.023"
    }, null, -1)
  ]))]))
}
export default { render: render }